import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "context/AppContext";
import OtpVerification from "subscreens/general/otpverification/OtpVerification";

function BuyerOtpVerification() {

    const { baseUrl, Navigate, authToken } = useContext(AppContext);
    const location = useLocation();
    const [email] = useState(location.state?.email || "");
    // Check OTP kis flow se aya hai
    const otpPurpose = location.state?.from || "signup";
    const [loading, setLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    // ==========================
    // VERIFY OTP
    // ==========================
    const handleVerify = (otp) => {
        setLoading(true);
        axios.post(
            `${baseUrl}/buyer/otp/verifyOtp`,
            {
                email: email,
                otp: otp,
            },
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            }
        )
            .then((response) => {
                if (response.data.success) {
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "OTP verified successfully.",
                    }).then(() => {
                        // ==========================
                        // SIGNUP FLOW
                        // ==========================
                        if (otpPurpose === "signup") {
                            Navigate("/buyer/login");
                        }
                        // ==========================
                        // FORGOT PASSWORD FLOW
                        // ==========================
                        else if (otpPurpose === "forgot-password") {
                            Navigate("/buyer/reset-password", {
                                state: {
                                    email: email,
                                },
                            });
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: response.data.message,
                    });
                }
                setLoading(false);
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text:
                        error.response?.data?.message ||
                        "Something went wrong.",
                });
                setLoading(false);
            });
    };
    // ==========================
    // RESEND OTP
    // ==========================
    const handleResend = () => {
        setResendLoading(true);
        axios.post(
            `${baseUrl}/buyer/otp/resendOtp`,
            {
                email: email,
            },
            {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            }
        )
            .then((response) => {
                console.log(response.data);
                Swal.fire({
                    icon: "success",
                    title: "OTP Sent",
                    text: response.data.message,
                });
                setResendLoading(false);
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text:
                        error.response?.data?.message ||
                        "Something went wrong.",
                });
                setResendLoading(false);
            });
    };
    return (
        <OtpVerification
            email={email}
            userType="buyer"
            handleVerify={handleVerify}
            handleResend={handleResend}
            loading={loading}
            resendLoading={resendLoading}
        />
    );
}
export default BuyerOtpVerification;

